export default __webpack_public_path__ + "static/media/skade_kostnad.898ffb1f.svg";